import { Box, Code, HStack, Stack, Text } from "@chakra-ui/react";
import * as React from "react";
import { LuCopy } from "react-icons/lu";
import { useParams } from "react-router-dom";

import { getScript } from "../../api/workspace";
import { Button } from "../../components/button";
import { brand } from "../../lib/brand";

export default function PixelPage() {
  const { workspace } = useParams();
  const [script, setScript] = React.useState("");
  const [copied, setCopied] = React.useState(false);
  const loadScript = React.useCallback(() => {
    getScript(workspace).then((raw) => {
      const script = raw
        .split("\n")
        .map((line) => "  " + line)
        .join("\n")
        .trimEnd();
      setScript(`<script>\n${script}\n</script>`);
    });
  }, [workspace]);
  const copyScript = React.useCallback(() => {
    navigator.clipboard.writeText(script);
    setCopied(true);
    setTimeout(() => setCopied(false), 1600);
  }, [script]);
  React.useEffect(() => {
    loadScript();
  }, [loadScript]);

  return (
    <Box
      background="white"
      borderRadius="l3"
      boxShadow="card"
      maxWidth={"920px" as any}
      overflow="hidden"
      width="full"
    >
      <HStack
        align="flex-start"
        borderBottomWidth="1"
        borderColor="border.soft"
        gap="4"
        justify="space-between"
        paddingX="6"
        paddingY="4"
      >
        <Stack gap="0.5">
          <Text color="fg.ink" fontSize="md" fontWeight="medium">
            Pixel
          </Text>
          <Text color="fg.muted" fontSize="sm">
            Allows {brand.productName} to see and learn from site activity and
            conversions. Paste in the{" "}
            <Code colorPalette="gray">&lt;head&gt;</Code> of your website.
          </Text>
        </Stack>
        <Button
          flexShrink="0"
          minWidth={"132px" as any}
          onClick={copyScript}
          variant="surface"
        >
          <LuCopy size="16" /> {copied ? "Copied" : "Copy snippet"}
        </Button>
      </HStack>
      <Box padding="6">
        <Box
          background="bg.subtle"
          borderRadius="l2"
          boxShadow="insetRing"
          overflowX="auto"
          paddingX={"18px" as any}
          paddingY="4"
        >
          <Text
            as="pre"
            color="fg"
            fontFamily="mono"
            fontSize="xs"
            lineHeight={"1.65" as any}
            whiteSpace="pre"
          >
            {script}
          </Text>
        </Box>
      </Box>
    </Box>
  );
}
